import { DesignMap } from '../../../../types';
import { BaseChangeItemConflict } from '../types';
import { getChangeItemLabel } from './get-change-item-label';

export interface GetConflictItemLabelProps {
  conflictItem: BaseChangeItemConflict;
  sourceDesignMap: DesignMap;
  targetDesignMap: DesignMap;
}

export function getConflictItemLabel({
  conflictItem,
  sourceDesignMap,
  targetDesignMap
}: GetConflictItemLabelProps): string {
  const { key, source, target } = conflictItem;

  return getChangeItemLabel({
    key,
    changeItem: source,
    designMap: sourceDesignMap
  }) ?? getChangeItemLabel({
    key,
    changeItem: target,
    designMap: targetDesignMap
  }) ?? '<Label Not Found>';
}
